module.exports = "/img/43.d236e2.webp";